module.exports = __webpack_public_path__ + "static/media/Emails.5b9991de.svg";